module.exports = __webpack_public_path__ + "static/media/background2.7ac27e61.png";